// extracted by mini-css-extract-plugin
module.exports = {"footer":"s_footer__2MzXA","footerInner":"s_footerInner__3Dw4C","footB":"s_footB__2nnbu","footerInfo":"s_footerInfo__-ZBZW"};